import { render, staticRenderFns } from "./Proyeccion.vue?vue&type=template&id=14fb7a57&"
import script from "./Proyeccion.vue?vue&type=script&lang=js&"
export * from "./Proyeccion.vue?vue&type=script&lang=js&"
import style0 from "./Proyeccion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports